import React from "react";
import {Box, MenuItem, Select, Stack, Typography} from "@mui/material";

export const PANEL_SX = {
  bgcolor: "#fff",
  border: "1px solid #ECECF3",
  borderRadius: "18px",
  boxShadow: "0 1px 2px rgba(35, 38, 77, 0.04)",
  minWidth: 0,
};

// White card of a dashboard row
export const Panel = ({children, sx, ...props}) => (
  <Box {...props} sx={{...PANEL_SX, display: "flex", flexDirection: "column", ...sx}}>{children}</Box>
);

// Kicker (small caps), title (+ count) and description of a panel, with actions on the right
export const PanelHeading = ({kicker, title, count, description, actions}) => (
  <Stack direction={"row"} justifyContent={"space-between"} alignItems={"flex-start"} gap={1.5}>
    <Box sx={{minWidth: 0, flex: "1 1 0"}}>
      {/*<Typography sx={{fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", color: "#8491F7"}}>{kicker}</Typography>*/}
      <Stack direction={"row"} alignItems={"center"} gap={1} sx={{mt: 0.5}}>
        <Typography component={"h2"} sx={{fontSize: 18, fontWeight: 700, color: "#23264D", letterSpacing: "-0.01em"}}>
          {title}
        </Typography>
        {count !== undefined && count !== null && (
          <Box component={"span"} sx={{
            px: 1, py: 0.25, borderRadius: "999px", fontSize: 12, fontWeight: 600,
            color: "#4B55C9", bgcolor: "rgba(132, 145, 247, 0.14)",
          }}>
            {count.toLocaleString()}
          </Box>
        )}
      </Stack>
      {description && <Typography sx={{mt: 0.25, fontSize: 13, color: "#8A8AA0"}}>{description}</Typography>}
    </Box>
    {actions && <Stack direction={"row"} gap={1} flexWrap={"wrap"} sx={{flexShrink: 0}}>{actions}</Stack>}
  </Stack>
);

// Small bordered control (search field / select) used in panel headings
export const controlSx = {
  height: 36,
  display: "flex",
  alignItems: "center",
  gap: 1,
  px: 1.25,
  borderRadius: "10px",
  border: "1px solid #E4E4EE",
  bgcolor: "#fff",
  color: "#6B6B80",
  fontSize: 13,
  "&:hover": {borderColor: "#D6D6E4"},
  "&:focus-within": {borderColor: "#8491F7"},
};

// Small pill dropdown for a panel's range ("Today", "Last 7 days", ...). options: [{value, label}].
// placeholder: shown (muted) while the value is "" - e.g. "Language" for a filter that matches everything when empty.
export const PillSelect = ({value, options, onChange, ariaLabel, placeholder}) => {
  const empty = placeholder && (value === "" || value === null || value === undefined);
  return (
    <Select
      variant={"standard"}
      disableUnderline
      displayEmpty={Boolean(placeholder)}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      renderValue={placeholder
        ? (selected) => empty ? placeholder : options.find(option => option.value === selected)?.label ?? selected
        : undefined}
      inputProps={{"aria-label": ariaLabel}}
      sx={{
        fontSize: 12, fontWeight: 500, borderRadius: "999px", px: 1.25,
        color: empty ? "#8A8AA0" : "#4B55C9",
        bgcolor: empty ? "#F2F2F7" : "rgba(132, 145, 247, 0.12)",
        "& .MuiSelect-select": {py: 0.5, pr: "22px !important"},
        "& .MuiSelect-icon": {color: empty ? "#8A8AA0" : "#4B55C9"},
      }}
      MenuProps={{PaperProps: {sx: {borderRadius: "12px", mt: 0.5}}}}
    >
      {options.map(option => <MenuItem key={option.value} value={option.value} dense>{option.label}</MenuItem>)}
    </Select>
  );
};
